import React, { useState, useEffect, useRef } from "react";
import S from './style';

const webinars = [
  { id: "HFiRtmGIWQc", title: "Orhun Isikoglu - ESHRE 42nd Annual Meeting" },
  { id: "ZbGrAzMiy9E", title: "UKSEAD - Akademik Webinar - 19" },
  { id: "hlbKfb-5KgA", title: "13th TFRM Scientific Meeting 2025" },
  { id: "4ilukG0rCC8", title: "TSRM 13 Şubat 2022 Sempozyum" },
  { id: "iCb8i8jFrlw", title: "Türkiye'de Konvansiyonel IVF Neden Yok?" },
  { id: "j4BoJCXBl-Y", title: "JournalClub - Good Practice Recommendations", thumbnail: "hqdefault.jpg" },
  { id: "bmbnZ-MWY0w", title: "Konvansiyonel IVF Geri Dönüyor" },
  { id: "yrgocymffsQ", title: "Add Ons In IVF Are They Worth The Burden" },
  { id: "0Gm7L9vKEHI", title: "Türkiye'de Konvansiyonel IVF Neden Yok" }
];

function MultipleItems() {
    const [activeVideo, setActiveVideo] = useState(null);
    const [hoveredVideo, setHoveredVideo] = useState(webinars[0]);
    const [isHovered, setIsHovered] = useState(false);
    const activeItemRef = useRef(null);

    const openModal = (video) => setActiveVideo(video);
    const closeModal = () => setActiveVideo(null);

    // Auto-advance logic
    useEffect(() => {
        if (isHovered || activeVideo) return; // Döngü durur

        const timer = setInterval(() => {
            setHoveredVideo((prev) => {
                const limitedWebinars = webinars.slice(0, 6);
                const currentIndex = limitedWebinars.findIndex((v) => v.id === prev.id);
                const nextIndex = (currentIndex + 1) % limitedWebinars.length;
                return limitedWebinars[nextIndex];
            });
        }, 5000); // 5 saniye arayla bir alta geçer

        return () => clearInterval(timer);
    }, [isHovered, activeVideo]);

    // Auto-scroll to active item (safely, without scrolling the whole window)
    useEffect(() => {
        if (activeItemRef.current) {
            const parent = activeItemRef.current.parentElement;
            if (parent) {
                const itemTop = activeItemRef.current.offsetTop;
                const itemHeight = activeItemRef.current.offsetHeight;
                const parentHeight = parent.clientHeight;
                const parentScroll = parent.scrollTop;

                if (itemTop < parentScroll) {
                    parent.scrollTo({ top: itemTop, behavior: 'smooth' });
                } else if (itemTop + itemHeight > parentScroll + parentHeight) {
                    parent.scrollTo({ top: itemTop - parentHeight + itemHeight, behavior: 'smooth' });
                }
            }
        }
    }, [hoveredVideo]);

    const displayWebinars = webinars.slice(0, 6);

    return (
        <S.MasterDetailWrapper
            onMouseEnter={() => setIsHovered(true)} 
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className="left-column">
                <ul className="webinar-list">
                    {displayWebinars.map((video, index) => {
                        const isActive = hoveredVideo.id === video.id;
                        return (
                            <li 
                                key={index} 
                                ref={isActive ? activeItemRef : null}
                                className={`list-item ${isActive ? 'active' : ''}`}
                                onMouseEnter={() => setHoveredVideo(video)}
                                onClick={() => openModal(video)}
                            >
                                <div className="item-title">{video.title}</div>
                                <div className="item-icon">
                                    <svg viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M8 5v14l11-7z"/>
                                    </svg>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>

            <div className="right-column" onClick={() => openModal(hoveredVideo)}>
                <div className="detail-card">
                    <div className="iframe-wrapper">
                        <img src={`https://img.youtube.com/vi/${hoveredVideo.id}/${hoveredVideo.thumbnail || 'maxresdefault.jpg'}`} alt={hoveredVideo.title} />
                        <div className="gradient-overlay"></div>
                        <div className="play-button-overlay">
                            <svg viewBox="0 0 24 24" fill="currentColor">
                                <path d="M8 5v14l11-7z"/>
                            </svg>
                        </div>
                        <div className="detail-title">
                            <h3>{hoveredVideo.title}</h3>
                        </div>
                    </div>
                </div>
            </div>

            {activeVideo && (
                <S.ModalOverlay onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="close-btn" onClick={closeModal}>
                            <svg viewBox="0 0 24 24" fill="currentColor">
                                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                            </svg>
                        </button>
                        <div className="modal-video-wrapper">
                            <iframe 
                                src={`https://www.youtube.com/embed/${activeVideo.id}?autoplay=1`}
                                title={activeVideo.title} 
                                frameBorder="0" 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                                allowFullScreen>
                            </iframe>
                        </div>
                    </div>
                </S.ModalOverlay>
            )}
        </S.MasterDetailWrapper>
    );
}

export default MultipleItems;
